import { FontFamily, StyleType, BusinessType } from "../model/enums/state.enums";
import { BusinessConfiguration } from "../model/interfaces/state.model";

const CONTACT_DATA = {
    street: null,
    city: null,
    state: null,
    name: null,
    phone: null,
    email: null,
    mobile: null,
    owner: { firstname: null, surname: null }
};

const DEFAULT_OPENING_HOURS = {
    regularOpeningHours: [
        { day: 'Montag', periods: [] },
        { day: 'Dienstag', periods: [] },
        { day: 'Mittwoch', periods: [] },
        { day: 'Donnerstag', periods: [] },
        { day: 'Freitag', periods: [] },
        { day: 'Samstag', periods: [] },
        { day: 'Sonntag', periods: [] }
    ],
    holidayOpeningHours: {
        stateHoliday: null,
        stateHolidaySync: true,
        defaultPeriods: [],
        days: []
    },
    specialDayOpeningHours:
        [
            // { date: '01.01.2025', periods: [] }
        ],
    listingSync: false,
    differentOpeningHoursNotification: {
        notificationText: "Das Unternehmen hat abweichende Öffnungszeiten",
        notificationRange: 14
    }

};

const LEGAL_DATA = {
    businessName: "Testunternehmen",
    businessType: BusinessType.SelfEmployed,
    vatId: null,
    registrationNumber: null,
    registrationCity: null,
    businessStreet: {
        value: null,
        syncWithContactData: true
    },
    businessCity: {
        value: null,
        syncWithContactData: true
    },
    businessContactNames: [],
    businessContactPhone: {
        value: null,
        syncWithContactData: true
    },
    businessContactEmail: {
        value: null,
        syncWithContactData: true
    },
    managerContentName: {
        value: null,
        syncWithContactData: true
    },
    managerContentStreet: {
        value: null,
        syncWithContactData: true
    },
    managerContentCity: {
        value: null,
        syncWithContactData: true
    },
    managerContentPhone: {
        value: null,
        syncWithContactData: true
    },
    managerContentEmail: {
        value: null,
        syncWithContactData: true
    },
    managerDataPrivacyName: {
        value: null,
        syncWithContactData: true
    },
    managerDataPrivacyStreet: {
        value: null,
        syncWithContactData: true
    },
    managerDataPrivacyCity: {
        value: null,
        syncWithContactData: true
    },
    managerDataPrivacyPhone: {
        value: null,
        syncWithContactData: true
    },
    managerDataPrivacyEmail: {
        value: null,
        syncWithContactData: true
    },
    useImprintTemplate: true,
    useDataPrivacyTemplate: true,
    customImprintContent: "",
    customDataPrivacyContent: "",
}

const DEFAULT_THEMING = {
    colors: {
        primaryColor: "#ff9800",
        secondaryColor: null,
        tertiaryColor: null,
        neutralColor: null,
        neutralVariantColor: null,
        errorColor: null,
    },
    bannerColors: {
        success: "#4caf50",
        warn: "#ff9800",
        error: "#f44336",
        font: "#ede0dd"
    },

    lightMode: true,
    typography: {
        brandTypography: FontFamily.DancingScript,
        plainTypography: FontFamily.Nunito,
    }
}

const DEFAULT_WIDGET_CONFIGURATION = {
    quickActions: {
        isEnabled: true,
        position: 'bottom-right' as const,
        items: [
            {
                id: 'phone',
                type: 'phone' as const,
                isActive: true,
                order: 1
            },
            {
                id: 'email',
                type: 'email' as const,
                isActive: true,
                order: 2
            },
            {
                id: 'whatsapp',
                type: 'whatsapp' as const,
                isActive: true,
                order: 3
            },
            {
                id: 'order',
                type: 'order' as const,
                isActive: true,
                order: 4
            },
            {
                id: 'contact-form',
                type: 'contact-form' as const,
                isActive: true,
                order: 998 // Fixed position: second to last
            },
            {
                id: 'directions',
                type: 'directions' as const,
                isActive: true,
                order: 999 // Fixed position: second to last with contact-form
            },
            {
                id: 'social',
                type: 'social' as const,
                isActive: true,
                order: 1000 // Fixed position: always last
            }
        ]
    }
}

export const DEFAULT_BUSINESS_CONFIGURATION: BusinessConfiguration = {
    shopId: null,
    showOpeningBanner: false,
    showDeliveryPopup: false,
    navbarGroups: [],
    openingHours: DEFAULT_OPENING_HOURS,
    contactData: CONTACT_DATA,
    legalData: LEGAL_DATA,
    reviewCount: 10,
    theming: DEFAULT_THEMING,
    reviews: [],
    partnerLinks: [],
    socialMediaLinks: [],
    widgets: DEFAULT_WIDGET_CONFIGURATION,
}

export const ALLOWED_TEXT_STYLES: StyleType[] = [
    StyleType.Color,
    StyleType.BackgroundColor,
    StyleType.FontSize,
    StyleType.FontWeight,
    StyleType.TextAlign
];

export const ALLOWED_BUTTON_STYLES: StyleType[] = [
    StyleType.BackgroundColor,
    StyleType.Color,
    StyleType.FontSize,
    StyleType.FontWeight,
];



